var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top",staticStyle:{"text-align":"center"}},[_c('h3',{staticStyle:{"margin":"20px 0"}},[_vm._v(_vm._s(_vm.list.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.list.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }